import React, { Component } from 'react'; 
import { Row, Table, Button, Alert, ModalHeader, Modal,ModalBody, Input} from 'reactstrap';
import Toggle from "react-toggle";
import axios from '../../axios';
import * as url from '../../utils/url';
import findIndex from 'lodash/findIndex';
import {groupRoles,createGroupMember, profilePicValidityCheck} from '../../utils/constants';
import Checkbox from 'rc-checkbox';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; 
import * as actionCreators from '../../modules/actions/index';
// import ReactPlayer from 'react-player'
import ReactPlayer from 'react-player/lazy'
import moment from 'moment';
import './AddToGroup.css';




class AddMember extends Component {

	constructor(props) {
    super(props);
			this.state = { 
				groupList:[],
				isChecked:[],
				displayItems:[],
				currentMembers:this.props.members&&this.props.members.length>0?this.props.members.map(e=>e.o_id):[],
				removeUsers:[],
				useres:[],
				invitedUsers:[],
				group:this.props.group,
				searchedUser:'',
				selected:null,
				groups:[],
				searchedTerm:'',
				date_joined:new Date()
		  }
		  this.timer=null;
    }


componentDidMount(){	
	if(this.props.isOpen ){
		if(!this.state.group || this.state.group==null) {
			axios.post(url.getGroups).then(({ data }) => {
				let resp = data.data
				this.setState({
					groupList: resp
				})
			  }).catch((error) => {
				console.log(error);
			  }) 
		}
	}
}

componentDidUpdate(prevProps,prevState){
	if(this.props.members.length!=prevProps.members.length){
		this.setState({currentMembers:this.props.members.map(e=>e.o_id)})
	}	
}
 


assignedUserDelay = ({ target })=>{
	const { value } = target;  
	this.setState({ searchedUser: value })
	clearTimeout(this.timer);
	this.timer = setTimeout(() => {
	  this.handleAssignUser(value);
	}, 1000);
   
  }
  
  handleAssignUser = value => {
	  this.setState({users:[]})
	  let{invitedUsers,date_joined,currentMembers}=this.state
	//   let currentMembers = [...this.props.group.members, ...invitedUsers]
	
	  if(value && value.length>0){
	  let payload = {
		name:value,
		removeUsers: this.state.removeUsers,
		noLoader: true,
		isGroup:true,
		date_joined,
		currentMembers 
	  }
  
	  axios.post(url.searchUsers, payload).then( (resp,idx) =>{
		let users = resp.data.data
  
		if(users.length==0){
		  users="no_users"
		}
  
		this.setState({users})
	  })
	} else {
	  this.setState({users:[]})
	}
  
  }
  
  assignedUserFormat=selectedUser=>{
	let{removeUsers,date_joined}=this.state
	// let obj = {
	//   fullName: `${selectedUser.firstName} ${selectedUser.lastName}`,
	//   user: selectedUser
	// }
	if( (removeUsers.indexOf(selectedUser._id)==-1 || removeUsers.length==0) && selectedUser.isCurrentMember!=true){
	  let userId = selectedUser._id
	  let organizationId = selectedUser.organizationId
	  // delete selectedUser._id
	  // delete selectedUser.organizationId
	  let invitedBy = this.props.user._id
	  let u = createGroupMember(selectedUser, invitedBy, date_joined, 'Member') 
		u={...u, justAdded:true}
	  let invitedUsers = this.state.invitedUsers.concat(u)
	  this.setState(prevState=>({
		invitedUsers,
		removeUsers: prevState.removeUsers.concat(selectedUser._id), 
		users: [],
		searchedUser:''
	  }))
	//   this.props.handleInvitedUsers(invitedUsers.length)
	}
  }
  

removeUser = user =>{
	let{invitedUsers,removeUsers}=this.state 
	removeUsers = removeUsers.filter(e=> e!=user.o_id)
	invitedUsers = invitedUsers.filter(e=> e.o_id!=user.o_id)
	this.setState({ invitedUsers ,
		removeUsers,
	})
  }
  
  getInitials=(user)=>{
	let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
	let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
	return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
  }
  
  viewGroup = grp => { 
	this.props.history.push(`/home/groups/${this.props.user.organizationId._id}/view/${grp}`)
  }



  closeGroupModal=()=>{
	this.setState({groupList:[],
		isChecked:[],
		displayItems:[],
		removeUsers:[],
		useres:[],
		invitedUsers:[],
		group:this.props.group,
		searchedUser:'',
		selected:null,
		groups:[],
		searchedTerm:'',
		date_joined:new Date()})
	this.props.closeGroupModal()
  }


  inviteUsers=()=>{
	let{invitedUsers, date_joined}=this.state
	let payload={
		new_members:invitedUsers,
		noLoader:true,
		invitedBy: this.props.user._id,
		groupObj: {...this.props.group, date_joined}
	}
	let that=this


	axios.post(url.addGroupMembers, payload).then(({ data }) => {
		console.log('data ---', data.data)
		that.setState({members:data.data})

		that.closeGroupModal()
		that.props.changeMemberLength(invitedUsers)

		// let groupId = data.data._id
		// let url =`/home/groups/${user.profile.organizationId._id}/view/${groupId}`
		// that.props.history.push({pathname : url });
	  }).catch((error) => {
		console.log(error);
	  }) 
  }
 

  renderContent=()=>{
	let{group,isOpen}=this.props
	  
	if(isOpen){
		if(group&&group._id){
			return  this.renderUserSelect()
		}else {
			return this.renderGroupSelect()
		}
	}  
	
  }
//   .custom_left_section_menu_fields .grp_invite_user_input_item

  renderUserSelect=()=>{
	  let{invitedUsers,searchedUser,users}=this.state
	  return(
		  	<span className="custom_left_section_menu_fields">
		<div className="floating-label-group grp_invite_user_input_item">
		{invitedUsers.length>0?
		<div className="grp_invite_user_input_invited_users_container">
		  { invitedUsers.map((e,idx)=>{
		  return (<span key={e.o_id+idx} className="grp_invite_user_input_invited_users">
					  {profilePicValidityCheck(e.profilePic)?
						  <img className="grp_create_search_user_pic" src={e.profilePic}/>
							:
						  <span className="spotlightUserInitials" data-letters={this.getInitials(e)}></span>
					  }
				{e.firstName} {e.lastName?e.lastName:''}
				<i onClick={()=>this.removeUser(e)}
				className="flaticon-trash"/></span>)
		  })}
		  </div>
			:
		  null}
		<input type="text" id="invitedUsers" className="form-control"
			onChange={this.assignedUserDelay} 
			value={searchedUser}
			autoComplete="off"  placeholder=' '/>
		<label className={invitedUsers.length>0?'floating_label_invite_user':`floating-label`}> Invite members </label>
		{Array.isArray(users) && users.length>0?
		  <span className="grp_create_search_user_res">
			  <div className="divTable">
			  <div className="divTableBody">
				  
				  {users.map( user => {
					return (
						<div className={`divTableRow ${user.isCurrentMember?'cursor-default':''}`} onClick={ user.isCurrentMember!=true? 
							()=>this.assignedUserFormat(user):null} key={user._id+user.organizationId}>
						  <div className="divTableCell">
							{profilePicValidityCheck(user.profilePic)?
							<img className="grp_create_search_user_pic" src={user.profilePic}/>
							:
							<span className="spotlightUserInitials" data-letters={this.getInitials(user)}></span>
							}
							<span className="add_member_modal_user_details">
							{user.firstName} {user.lastName}
							{user.isCurrentMember?
							<span className="add_member_modal_disable"> already invited </span>:null}
							</span>
						  </div>
						  </div>
					  )
					})}
				
												
				</div>
			  </div>   
			</span>                   
			:
			users=='no_users'?
				<span className="grp_create_search_user_res">
					<div className="divTable">
						<div className="divTableBody">
							No users found
						</div>
					</div>
				</span>
			:null
			}

		
	  </div> 
	  			<div className={invitedUsers.length>0?`custom_left_menu_create_button active`:`custom_left_menu_create_button`}
						onClick={invitedUsers.length>0?()=>this.inviteUsers():null} >
						Add members  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                  <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                                  <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                                </svg>
				</div>

				<div className="custom_left_menu_create_button cursor-pointer add_member_modal_close_btn" 
				onClick={this.closeGroupModal} >
						Close
				</div>
	  </span>	
	  )
  }

  handleSearchQueryChanged = ({target}) => {
	const {name,value} = target;
	let { groupList} = this.state;
	let list = [];
	let fList = groupList
	if(value.length === 0) {
	  list = fList
	} else {
	  list = fList.filter(e=>e.name.toLowerCase().includes(value.toLowerCase()))
	}
	this.setState({
	  displayItems:list,
	  searchedTerm : value
	});
  }
  
  selectedGroup=(e, group)=>{
	  this.setState({group})
  }

renderGroupSelect =()=>{
	let{searchedTerm,selected, displayItems,group}=this.state
	return (
		<span>
				<div className="singleTaskModalBody">
                     Select a group below to add users to.  
                </div>

					<Input className="singleTaskItemSearch" placeholder="Search by name" 
                      onChange={this.handleSearchQueryChanged} value={searchedTerm}/>


					<div className="divTableBody">
					{displayItems.map( (itm,idx) => {
							return(
								<div className="radio ml0 mt0"  key={itm._id+idx}>
									<input id={itm._id} name="meRadio"
									onChange={(e) => this.selectedGroup(e, itm)}
									type="radio" value={itm._id} checked={ group && group._id==itm._id?true:'' }/>
									<label htmlFor={itm._id} className="radio-label privacy-radio-label privacy-radio-value">
									<span className="radio-label link_ent_obj_title">{itm.name}</span>
									</label>
								</div>)
						})}
                	</div>

						<div className="singleTaskModalBtn"
						style={{ padding: '10px 0px 0px 0px' }}>

					
                        <Button className={`profile-modal-save-btn float-left weeklyWinBtn ${group&&group._id?'':'noClickBtn'}`}
							onClick={group && group._id?()=>this.renderUserSelect():null} >
                          <span className="profile-modal-save-btn-txt">
                            Invite Members 
                          <span className="ml10 flaticon-tick"></span></span>
							</Button>

							<Button className="profile-modal-cancel-btn float-right weeklyWinBtn" onClick={this.closeGroupModal}>
							<span className="profile-modal-cancel-btn-txt">Close</span>
							</Button>
						</div>
		</span>
	)
  }

	render() {

		let { group} = this.state;
		// console.log('isChecked--- ', isChecked)
  		return (
			<Modal isOpen={this.props.isOpen} className="ent-obj-link-modal linkTaskItemsModal groupItemsModal">
						<ModalHeader className="dashboardHeader" charCode="X"
							toggle={this.closeGroupModal}
							>
							<div className="dashboardModalTitle">
								{group&&group._id? 
									<span>Invite users to "<strong>{group.name}</strong>"</span>
									: 'Select a Group'
								}
							</div>
						</ModalHeader>
				<ModalBody className="create-stories">

					{this.renderContent()}

				</ModalBody>
			</Modal>
			)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
	}
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddMember));


  
  